
import CargoCategory from './filters/CargoCategory.vue';
import LoadType from './filters/LoadTypes.vue'
import CustomerType from './filters/CustomerType.vue';
import LoadDate from './filters/LoadDate.vue';
import PickupDelivery from './filters/PickupDeliveryRegion.vue';
import RadiusCommon from './filters/RadiusCommon.vue';
import { DEFAULT_RADIUS } from '../../util/constants';
import Search from './filters/Search.vue';
export default { 
  components: { PickupDelivery, LoadType, LoadDate, CargoCategory, Search, CustomerType, RadiusCommon },
  props: {
    tab: {
      type: String,
      default: 'region'
    },
    routeValidation: {
      type: Object,
      default: ()=>{
        return{
          fromRequired: false,      
          toRequired: false
        }
      }
    },
    route: {
      type: Object,
      default: () => {
        return {
          from: null,      
          to: null, 
          category: null,
          pickupState: null
        }
      }
    }
  },
  data() {
    return {
      reset: false,
      isOnboarding: false,
      displayName: '',
      activeSettingsPage: false,
      activeStatus: false,
      filters: {
        pickup: {
          regionPrefixes: [],
          suburb: '',
          radius: null
        },
        delivery: {
          regionPrefixes: [],
          suburb: '',
          radius: null
        },
        radiusCommon: DEFAULT_RADIUS,
        cargoCategory: null,
        loadType: null,
        pickupState: null,
        deliveryState: null,
        customerType: null,
        loadDate: {
          dateType: null,
          from: null,
          to: null,
          selectedDateType: null
        },
        loadTypes: {
          isUrgent: false,
          isReadyNow: false,
          isRecent: false,
        },
        keyword: ''
      }
    };
  },
  watch: {
    filters : {
      handler() {
        this.$emit('filter-changed', this.filters)
      },
      deep: true,
      immediate: true
    },
    
    reset(){
      this.$emit('search', true)
    }
  },
  mounted() {
  },
  methods: {
    pickupChanged (value) {
      if(this.tab === 'state') {
        this.filters.pickupState = value
      }
      else {
        this.filters.pickup = value
      }
   },
    deliveryChanged (value) {
      if(this.tab === 'state') {
        this.filters.deliveryState = value
      }
      else {
        this.filters.delivery = value
      }
    },
    customerTypeChanged (value) {
      this.filters.customerType = value
    },
    radiusCommonChanged (value) {
      this.filters.radiusCommon = value
    },
    cargoCategoryChanged (value) {
      this.filters.cargoCategory = value
    },
    loadTypeChanged (value) {
      this.filters.loadTypes = value
    },
    loadDateChanged (value) {
      this.filters.loadDate = value
    },
    keywordChanged (value) {
      this.filters.keyword = value
    },
    searchLoads () {
      this.$emit('search')
    },
    serachWithTimeout () {
      this.$emit('search-with-timeout', this.filters)
    },
    serachWithTiemoutCategory (value) {

      this.$emit('search-with-timeout', this.filters)
    },
    resetFilters () {
      this.$router.replace({ query: {}})
      this.$emit('reset')
      this.reset = !this.reset
      this.filters ={
        pickup: {
          regionPrefixes: [],
          suburb: '',
          radius: null
        },
        delivery: {
          regionPrefixes: [],
          suburb: '',
          radius: null
        },
        radiusCommon: DEFAULT_RADIUS,
        pickupState: null,
        deliveryState: null,
        customerType: null,
        cargoCategory: null,
        loadDate: {
          dateType: null,
          from: null,
          to: null,
          selectedDateType: null
        },
        loadTypes: {
          isUrgent: false,
          isReadyNow: false,
          isRecent: false,
        },
        keyword: ''
      }
    }
  }
}
